import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';
import { User } from '@providers/asset/user/user';
import { LoginPage } from '../login/page';

@Component({
  selector: 'page-profile',
  templateUrl: 'page.html'
})
export class ProfilePage {

  emp:any;
  loading:any;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public userApi: User
  ) {
    this.emp = this.userApi.data;
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  logout(){
    this.userApi.is_login=0;
    this.userApi.data={};
    localStorage.clear();
    this.navCtrl.push(LoginPage);

  }
  
}



// WEBPACK FOOTER //
// ./src/pages/asset/profile/page.ts